/* DMØN — le script de la matière. 1 Ko, aucune dépendance.
   Chargé par les deux surfaces, à l'identique.

   Il ne fait qu'une chose : révéler les éléments quand ils entrent à l'écran.
   La classe `js` est posée en tout premier pour que les états masqués de
   matter.css ne s'appliquent QUE si ce script tourne. Sans lui, tout est
   visible d'emblée — il n'y a pas de contenu perdu possible. */

(function () {
  "use strict";

  var root = document.documentElement;
  root.classList.add("js");

  var calm = window.matchMedia("(prefers-reduced-motion: reduce)");

  function start() {
    var targets = document.querySelectorAll("[data-reveal], .d-rule");
    if (!targets.length) return;

    // Mouvement refusé, ou navigateur trop ancien : on arrive à destination
    // tout de suite. Jamais d'élément laissé invisible.
    if (calm.matches || !("IntersectionObserver" in window)) {
      targets.forEach(function (el) { el.classList.add("is-in", "is-done"); });
      return;
    }

    // Ce qui est déjà à l'écran au chargement est révélé tout de suite, sans
    // attendre l'observateur. Sinon le premier écran dépend d'un événement qui
    // peut ne jamais venir.
    function inView(el) {
      var r = el.getBoundingClientRect();
      return r.top < window.innerHeight && r.bottom > 0;
    }

    var seen = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          var el = entry.target;
          el.classList.add("is-in");
          seen.unobserve(el);
          el.addEventListener("transitionend", function () {
            el.classList.add("is-done");
          }, { once: true });
        });
      },
      { rootMargin: "0px 0px -12% 0px", threshold: 0.08 }
    );

    var atLoad = [];
    targets.forEach(function (el) {
      if (inView(el)) { atLoad.push(el); return; }
      seen.observe(el);
    });

    // Deux images d'attente avant de révéler ce qui est déjà à l'écran : sans
    // ça, le navigateur voit l'état initial et l'état final dans la même image
    // et saute la transition. C'est ce délai qui donne la cascade à l'ouverture.
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        atLoad.forEach(function (el) { el.classList.add("is-in"); });
      });
    });

    // Filet de sécurité. Si l'observateur ne se déclenche pas — navigateur
    // exotique, onglet jamais peint, extension qui bloque — le contenu apparaît
    // quand même. Une animation est un agrément ; la lisibilité, non.
    setTimeout(function () {
      document.querySelectorAll("[data-reveal]:not(.is-in), .d-rule:not(.is-in)")
        .forEach(function (el) { el.classList.add("is-in"); });
    }, 2000);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", start, { once: true });
  } else {
    start();
  }
})();
